import { Link } from 'react-router-dom';
import { useTranslation } from '../../../utils/useTranslation';
import { Tooltip } from '../../feedback/Tooltip';
import { IconHelp } from '../../icon/IconHelp';
import { Button } from '../../input/Button';
import { Box } from '../../layout/Box';
import { Flex } from '../../layout/Flex';
import { Typography } from '../../typography/Typography';
import { StatisticContent } from './parts/StatisticContent/StatisticContent';
import { BusinessStatisticProps } from './types';

export const BusinessStatistic = (props: BusinessStatisticProps) => {
    const t = useTranslation();
    const { statistic, statisticUrl, statisticLoading, onAllStatisticClick } = props;

    return (
        <Box py={1} px={{ xs: 2, sm: 3 }}>
            <Flex width="100%" borderRadius={2} pb={2}>
                <Flex
                    width="100%"
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                >
                    <Box pt={2} pb={1}>
                        <Flex direction="row" spacing={0.5} alignItems="center">
                            <Typography variant="body" weight="bold">
                                {t('Статистика')}
                            </Typography>
                            <Tooltip
                                trigger={
                                    <IconHelp
                                        color="var(--color-primary)"
                                        cursor="help"
                                        size={16}
                                    />
                                }
                            >
                                <Typography
                                    variant="caption"
                                    weight="bold"
                                    color="var(--color-invert)"
                                    display="inline"
                                >
                                    {t('Охват')}
                                </Typography>
                                <Typography
                                    variant="caption"
                                    color="var(--color-invert)"
                                    display="inline"
                                >
                                    {t(
                                        ' - количество уникальных аккаунтов, владельцы которых хотя бы 1 раз видели ваш контент за последние 7 дней, с изменением в процентах относительно предыдущих 7 дней. Эта метрика находится в разработке и возможны изменения в расчетах.',
                                    )}
                                </Typography>
                                <br />
                                <br />
                                <Typography
                                    variant="caption"
                                    weight="bold"
                                    color="var(--color-invert)"
                                    display="inline"
                                >
                                    {t('Подписчики (за весь срок существования профиля)')}
                                </Typography>
                                <Typography
                                    variant="caption"
                                    color="var(--color-invert)"
                                    display="inline"
                                >
                                    {t(
                                        ' - количество аккаунтов, подписавшихся на профиль за весь период с изменением в количестве подписавшихся за последние 7 дней.',
                                    )}
                                </Typography>
                                <br />
                                <br />
                                <Typography
                                    variant="caption"
                                    weight="bold"
                                    color="var(--color-invert)"
                                    display="inline"
                                >
                                    {t('Клики по ссылкам')}
                                </Typography>
                                <Typography
                                    variant="caption"
                                    color="var(--color-invert)"
                                    display="inline"
                                >
                                    {t(
                                        ' - количество переходов по ссылкам из контента и из профиля за последние 7 дней и изменение в процентах относительно предыдущих 7 дней',
                                    )}
                                </Typography>
                                <br />
                                <br />
                                <Typography
                                    variant="caption"
                                    weight="bold"
                                    color="var(--color-invert)"
                                    display="inline"
                                >
                                    {t('Вся статистика')}
                                </Typography>
                                <Typography
                                    variant="caption"
                                    color="var(--color-invert)"
                                    display="inline"
                                >
                                    {t(
                                        ' - переход на расширенную аналитику с возможностью посмотреть статистику за разные периоды и за все время существования профиля.',
                                    )}
                                </Typography>
                            </Tooltip>
                        </Flex>
                    </Box>
                    <Button
                        as={Link}
                        size="xs"
                        color="secondary"
                        to={statisticUrl}
                        onClick={onAllStatisticClick}
                    >
                        {t('Вся статистика')}
                    </Button>
                </Flex>
                <StatisticContent statisticLoading={statisticLoading} statistic={statistic} />
            </Flex>
        </Box>
    );
};
